<nav class="main-nav">
  <div class="logo">
    <a routerLink="/">
      <img src="devflow.png" alt="NV">
    </a>
  </div>

  <div class="nav-admin-info">
    <span>Admin Dashboard</span>
    <button class="logout-btn" (click)="logout()">Logout</button>
  </div>

  <ul class="nav-links">
    <li><a [routerLink]="['/portfolio']" fragment="about">Who am I?</a></li>
    <li><a [routerLink]="['/portfolio']" fragment="projects">Projects</a></li>
    <li><a [routerLink]="['/portfolio']" fragment="skills">Skills</a></li>
    <li><a [routerLink]="['/portfolio']" fragment="contact">Contact</a></li>
    <li><a [routerLink]="['/kanban']" routerLinkActive="active">Admin</a></li>
  </ul>
</nav>

<div class="admin-container">
  <section class="form-section">
    <div class="section-header">
      <h2>{{ editingProject?._id ? 'Edit Entry' : 'New Project' }}</h2>
    </div>

    <form (submit)="submitProject($event, editingProject)">
      <div class="field-row">
        <div class="field-group">
          <label>Project Title</label>
          <input type="text" [(ngModel)]="editingProject.title" name="title" required />
        </div>

        <div class="field-group">
          <label class="field-label">Project Thumbnail</label>
          <div class="upload-wrapper">
            <input type="text" 
                   [(ngModel)]="editingProject.imageUrl" 
                   name="imageUrl" 
                 placeholder="Cloud URL..." 
                 readonly 
                 class="upload-path-input"/>
    
          <input type="file" #fileInput (change)="onFileSelected($event)" style="display: none;">
    
          <button type="button" 
                  (click)="fileInput.click()" 
                  class="upload-btn"
                  [class.uploading]="isUploading">
            <span class="btn-text">{{ isUploading ? 'Uploading...' : 'Upload' }}</span>
          </button>
        </div>
      </div>
      </div>

      <div class="field-row three">
        <div class="field-group"><label>Year</label><input type="text" [(ngModel)]="editingProject.year" name="year" /></div>
        <div class="field-group"><label>Role</label><input type="text" [(ngModel)]="editingProject.role" name="role" /></div>
        <div class="field-group"><label>GitHub</label><input type="text" [(ngModel)]="editingProject.githubUrl" name="githubUrl" /></div>
      </div>

      <div class="field-group">
        <label>Tech Stack (Comma separated)</label>
        <input type="text" [(ngModel)]="skillsString" name="skills" placeholder="angular, nodejs..." />
      </div>

      <div class="field-group">
        <label>Description</label>
        <textarea [(ngModel)]="editingProject.desc" name="desc" class="desc-field"></textarea>
      </div>

      <div class="form-actions">
        <button type="submit" class="save-btn">{{ editingProject?._id ? 'Update' : 'Create' }}</button>
        <button type="button" (click)="cancelEdit()" class="cancel-btn">Clear</button>
      </div>
    </form>
  </section>

  

  <section class="list-section">
  <div class="admin-project-list">
    @for (project of projects; track project._id) {
      <div class="admin-card">
        <img [src]="project.imageUrl" alt="Preview" />
        
        <div class="admin-card-info">
          <h3>{{ project.title }}</h3>
          <p>{{ project.year }} • {{ project.role }}</p>
          
          <div class="admin-skill-icons" style="display: flex; gap: 8px; margin-top: 8px;">
            @for (slug of project.techStack; track slug) {
              <img 
                [src]="'https://cdn.simpleicons.org/' + slug + '/6FAF8F'" 
                [title]="slug"
                style="width: 18px; height: 18px;" 
                alt="icon" 
              />
            }
          </div>

          <div class="stats" style="margin-top: 5px; font-size: 0.8rem; color: #7A7977;">
            Views: {{ project.clicks || 0 }}
          </div>
        </div>

        <div class="admin-card-btns">
          <button class="edit-btn" (click)="editProject(project)">✏ Edit</button>
          <button class="delete-btn" (click)="removeProject(project._id)">✕ Delete</button>
        </div>
      </div>
    }

  </div>
</section>

<div class="section-gap"><span>Analytics & Activity</span></div>

  <section class="analytics-section">
    <div class="analytics-bar" *ngIf="activityData.length > 0">
      <div class="pill-container">
        @for (stat of activityData; track stat.click_date) {
          <div class="stat-pill">
            <span class="date">{{ stat.click_date | date:'MMM d, y' }} :</span>
            <span class="count">{{ stat.count }} unique views</span>
          </div>
        }
      </div>
    </div>
    
    <div class="no-data" *ngIf="activityData.length === 0">
      <p>Waiting for project traffic... (Database currently empty)</p>
    </div>
  </section>
</div>



